export const toastMessages = {
  theatreAddedToFavorites: 'Theatre Added to Favorites',
  unableToMarkTheatreAsFavorite: 'Unable to mark the theatre as favorite.',
} as const;
